module.exports = __webpack_public_path__ + "img/ls3-engine-complete.d8d982f6.jpg";